<template>
    <div
        :class="['switch-toggle', {
            'is-active': isChecked
        }]"
    >
        <input
            :id="uniqueId"
            type="checkbox"
            v-model="isChecked"
        />

        <label :for="uniqueId" class="switch-toggle__value-left">{{values[0]}}</label>

        <label
            :for="uniqueId"
            class="switch-toggle__rail"
        >
            <span class="switch-toggle__handle"></span>
        </label>

        <label :for="uniqueId" class="switch-toggle__value-right">{{values[1]}}</label>
    </div>
</template>

<script>
import { ref, watch } from 'vue';
import { uniqueId } from 'lodash';

export default {
    name: 'SwitchToggle',

    props: {
        defaultChecked: {
            type: Boolean,
            default: false
        },
        values: {
            type: Array,
            default: () => ([])
        }
    },

    setup(props, { emit }) {
        const isChecked = ref(props.defaultChecked);

        watch(isChecked, (newChecked) => {
            emit('on-change', newChecked)
        });

        return {
            isChecked,
            uniqueId: uniqueId()
        }
    }
}
</script>
